import { render } from "./Adminoverview.vue?vue&type=template&id=0e20cdbf&scoped=true"
import script from "./Adminoverview.vue?vue&type=script&lang=js"
export * from "./Adminoverview.vue?vue&type=script&lang=js"

import "./Adminoverview.vue?vue&type=style&index=0&id=0e20cdbf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e20cdbf"]])

export default __exports__